// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1aWqI","emails":"CreateEditClinics_emails__3034p","emailTagLabel":"CreateEditClinics_emailTagLabel__2zpDw"};